import API from "./api";

export const GetLanguageMaster = (configUrl: string) =>
    API.get(`${configUrl}api/master/Language`);

export const GetRelationshipMaster = (configUrl: any) =>
    API.get(`${configUrl}api/master/Relationship`);